export default __webpack_public_path__ + "static/19-12f9124155dbde844c8ec1e1f4d53ba2.png";